export default __webpack_public_path__ + "static/media/3.50b20cb5.jpg";